<template>
<section>
  <b-container fluid class="icon_labels" :style="{backgroundColor: getCssColor('icon_labels_bg')}">
    <b-row>
      <b-col class="icon_label_container">
        <div style="cursor:pointer;"><a @click="openMap()" style="text-decoration:none;" >
          <font-awesome-icon class="icon_labels_ico" style="clear:both;" :style="{color: getCssColor('icon_labels_icon')}"  :icon="['fas', 'shipping-fast']"/>
          <p :style="{color: getCssColor('icon_labels_font')}">
            <template v-if="$store.state.company.delivery_region">
              {{$store.state.company.delivery_region}}
            </template>
            <template v-else>
              Verifique área de entrega
            </template>
          </p></a>
        </div>
      </b-col>

      <b-col class="icon_label_container">
        <div>
          <font-awesome-icon class="icon_labels_ico" style="clear:both;" :style="{color: getCssColor('icon_labels_icon')}"  :icon="['fas', 'shield-check']"/>
          <p :style="{color: getCssColor('icon_labels_font')}">
            <template v-if="$store.state.company.security_information">
              {{$store.state.company.security_information}}
            </template>
            <template v-else>
              Site Seguro
            </template>
          </p>
        </div>
      </b-col>

      <b-col class="icon_label_container">
        <div style="cursor:pointer;" @click="showModalFlags = !showModalFlags">
          <font-awesome-icon class="icon_labels_ico" style="clear:both;" :style="{color: getCssColor('icon_labels_icon')}"  :icon="['fas', 'credit-card']"/>
          <p :style="{color: getCssColor('icon_labels_font')}">
            <template v-if="$store.state.company.cards_accepted">
              {{$store.state.company.cards_accepted}}
            </template>
            <template v-else>
              Aceitamos todos cartões
            </template>
          </p>
        </div>
      </b-col>
    </b-row>
    <Modal v-if="$store.state.company.card_flags && $store.state.company.card_flags.length" :showModal="showModalFlags" >
      <div @click="showModalFlags = false" style="z-index:19002;position:absolute;top:5px;right:5px;cursor:pointer;width:30px;height:30px;text-align:center;">
        <font-awesome-icon style="font-size:26px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
      </div>
      <div style="width:100%; height:100%;padding:10px;overflow:auto;">
        <b-container>
          <b-row align-h="center" v-for="(flag, idx) in $store.state.company.card_flags" v-bind:key="idx" style="height:40px;">
            <div class="col-4" ><img :src="$store.state.imgPath2 + flag.icon" alt="flag"/></div>
            <div class="col-4" style="height:29px;line-height:29px;font-weight:500;" >{{flag.name}}</div>
          </b-row>
        </b-container>
      </div>
    </Modal>
  </b-container>
</section>
</template>

<script>
import Modal from '@/components/Modal'
import colors from '@/mixins/colors'

export default {
  name: "IconLabels",

  data () {
    return {
      showModalFlags: false
    }
  },

  components: {Modal},
  mixins: [colors],

  methods: {
    openMap () {
      if (!this.$store.state.company.market_place) {
        this.$router.push({path:'/map'})
      }
    }
  }
  
}
</script>

<style lang="scss" scoped>
@import "@/css/_variables.scss";

.icon_labels {
  @media screen and (max-width: $mobile) {
    min-height:90px;
  }
  @media screen and (min-width: $mobile) and (max-width: $tablet) {
    min-height:110px;
  }
  @media screen and (min-width: $tablet) {
    min-height:148px;
  }

  .icon_labels_ico {
    @media screen and (max-width: $mobile) {
      font-size:24px;
    }
    @media screen and (min-width: $mobile) and (max-width: $tablet) {
      font-size:36px;
    }
    @media screen and (min-width: $tablet) {
      font-size:48px;
    }
  }

  .icon_label_container {
    @media screen and (max-width: $mobile) {
      margin-top:15px;
      min-height: 75px;
    }
    @media screen and (min-width: $mobile) and (max-width: $tablet) {
      margin-top:25px;
      min-height: 105px;
    }
    @media screen and (min-width: $tablet) {
      margin-top:35px;
      min-height: 133px;
    }
    text-align:center;
    p {
      margin: 5px;
      @media screen and (max-width: $mobile) {
        font-size:12px;
        line-height:13px;
      }
      @media screen and (min-width: $mobile) and (max-width: $tablet) {
        font-size:16px;
        line-height:16px;
      }
      @media screen and (min-width: $tablet) {
        font-size:18px;
        line-height:18px;
      }
    }
  }
}
</style>
